module.exports = __webpack_public_path__ + "static/media/English_US_Paul BG-36.7b9e08b1.png";